import * as React from "react"
import * as ReactDOM from "react-dom"

interface AcademicianDetail {
    AdSoyad: string;
    AkademikGorevListesi: string;
    ArastirmaSertifkaBilgisi: string;
    BildiriBilgisi: string;
    DersListesi: string;
    EditorlukBilgisi: string;
    Gorev: string;
    GorevTipi: string;
    HakemlikBilgisi: string;
    IdariGorevListesi: string;
    KitapBilgisi: string;
    MakaleBilgisi: string;
    OdulListesi: string;
    OgrenimBilgisiListesi: string;
    Organizasyon: string;
    PatentBilgisi: string;
    Pozisyon: string;
    ProjeListesi: string;
    RegisterID: string;
    Resim: string;
    SanatsalFaal: string;
    TasarimBilgisi: string;
    TemelAlanBilgisi: string;
    TezDanismanListesi: string;
    UnvDisiDeneyimListesi: string;
    Unvan: string;
    YabanciDilListesi: string;
}

interface AcademicianDetailResponse {
    Result: AcademicianDetail;
    StatusCode: number;
}

interface IAhAcademicianDetailViewProps {

    PageItemID: number;
    itemProperties: {
    };
    initialState: AhAcademicianDetailViewModel<AhAcademicianDetailViewItemModel>;
}

class AhAcademicianDetailViewModel<T> {
    PageItemID: number;
    FormState: FormState;
    SelectedMenuIndex: number;
    Data: AcademicianDetail;

    items: Array<T>;
    constructor() {
        this.items = new Array<T>();
        this.FormState = FormState.Loaded;
        this.SelectedMenuIndex = 0;
    }
}

class AhAcademicianDetailViewItemModel {
}

enum FormState {
    Loading,
    Loaded,
    Saved
}

export class AhAcademicianDetailView extends React.Component<IAhAcademicianDetailViewProps, AhAcademicianDetailViewModel<AhAcademicianDetailViewItemModel>>{
    private leftMenuOptions = ["Genel Bilgiler", "Öğrenim Bilgisi", "ÜAK Temel Alan", "Akademik Unvanlar", "İdari Görevler", "Makaleler", "Kitaplar", "Bildiriler", "Projeler", "Sanatsal Faaliyetler", "Yönetilen Tezler", "Dersler", "Araştırma, Sertifika, Kurs ve Üyelikler", "Tasarım, Ödüller ve Patentler", "Üniversite Dışı Deneyim", "Editörlük", "Yayın Hakemliği"];
    constructor(props: IAhAcademicianDetailViewProps) {
        super(props);
        this.state = (!this.props.initialState) ? new AhAcademicianDetailViewModel<AhAcademicianDetailViewItemModel>() : this.props.initialState;
    }

    componentDidMount() {
        this.setState({ FormState: FormState.Loading });
        fetch('/_vti_bin/Halic/AjaxHandler.svc/academician/get', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.state.PageItemID)
        }).then((rawResponse) => {
            rawResponse.json()
                .then((result: AcademicianDetailResponse) => {
                    this.setState({ FormState: FormState.Saved, Data: result.Result });
                })
                .catch((err) => {
                    alert("Beklenmedik bir sorun oluştu.");
                    console.error(err);
                });
        }).catch((err) => {
            alert("Beklenmedik bir sorun oluştu.");
            console.error(err);
        });
    }

    private getLeftMenu = () => {
        return <div className="leftSidebar">
            <div className="menu">
                <ul>
                    {this.leftMenuOptions.map((menu, index) => {
                        return <li ><a href="#" onClick={this.onSelectMenu.bind(this, index)} className={`${this.state.SelectedMenuIndex === index ? "active" : ""}`}>{menu}</a></li>
                    })}
                </ul>
            </div>
        </div>
    }

    private getNotFoundContent = () => {
        return <div role="alert" className="alert alert-info awsome">
            <strong className="">Dikkat!</strong><br />
            <span className=""> Belirtmiş olduğunuz sayfaya ait kayıtlı içerik bulunmamaktadır. </span>
        </div>;
    }
    private getDetailComponent = () => {
        switch (this.state.SelectedMenuIndex) {
            case 0:
                return <table className="table table-striped responsive mt-5">
                    <tbody>
                        <tr>
                            <th> Unvan: </th>
                            <td> {this.state.Data.Unvan} </td>
                        </tr>
                        <tr>
                            <th> Birim: </th>
                            <td> {this.state.Data.Organizasyon} </td>
                        </tr>
                        <tr>
                            <th> Görev: </th>
                            <td> {this.state.Data.Gorev} </td>
                        </tr>
                    </tbody>
                </table>
                break;
            case 1:
                let OgrenimBilgisiListesi = JSON.parse(this.state.Data.OgrenimBilgisiListesi);

                return OgrenimBilgisiListesi && OgrenimBilgisiListesi.data ?
                    OgrenimBilgisiListesi.data.map((ogrenimBilgisi) => {
                        return <div className="mt-5">
                            <div className="cardList">
                                <div className="card">
                                    <div className="cardHeading">{ogrenimBilgisi.pROGRAM_ADIField}</div>
                                    <div className="card-content">
                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <th className="w-25">Üniversite</th>
                                                    <td> {ogrenimBilgisi.uNV_BIRIM_ADIField}</td>
                                                </tr>
                                                <tr className="">
                                                    <th>Fakülte</th>
                                                    <td> {ogrenimBilgisi.fAKULTEBILGISIField}</td>
                                                </tr>
                                                <tr className="">
                                                    <th>Bölüm</th>
                                                    <td>{ogrenimBilgisi.bOLUMBILGISIField}</td>
                                                </tr>
                                                <tr>
                                                    <th>Başlangıç - Bitiş Yıl</th>
                                                    <td>{`${ogrenimBilgisi.bASTAR1Field} / ${ogrenimBilgisi.bITTAR1Field}`}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    })
                    : this.getNotFoundContent();
                break;
            case 2:
                let TemelAlanBilgisi = JSON.parse(this.state.Data.TemelAlanBilgisi);

                return TemelAlanBilgisi && TemelAlanBilgisi.data ?
                    TemelAlanBilgisi.data.map((temelAlan) => {
                        return <div className="mt-5">
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <th className="w-25">ÜAK Temel Alanı</th>
                                        <td>{temelAlan.tEMEL_ALAN_ADField}</td>
                                    </tr>
                                    <tr>
                                        <th>Bilim Alanı</th>
                                        <td>{temelAlan.bILIM_ALAN_ADField}</td>
                                    </tr>
                                    <tr>
                                        <th>Anahtar Kelime 1</th>
                                        <td>{temelAlan.aNAHTARKELIME1_ADField}</td>
                                    </tr>
                                    <tr>
                                        <th>Anahtar Kelime 2</th>
                                        <td>{temelAlan.aNAHTARKELIME2_ADField}</td>
                                    </tr>
                                    <tr>
                                        <th>Anahtar Kelime 3</th>
                                        <td>{temelAlan.aNAHTARKELIME3_ADField}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    })
                    : this.getNotFoundContent();
                break;
            case 3:
                let AkademikGorevListesi = JSON.parse(this.state.Data.AkademikGorevListesi);

                return AkademikGorevListesi && AkademikGorevListesi.data ?
                    AkademikGorevListesi.data.map((akademikGorev) => {
                        return <div className="mt-5">
                            <div className="cardList">
                                <div className="card">
                                    <div className="cardHeading">{akademikGorev.kADRO_UNVAN_ADIField}</div>
                                    <div className="card-content">
                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <th className="w-25">Üniversite</th>
                                                    <td> {akademikGorev.uNIV_BIRIM_ADIField}</td>
                                                </tr>
                                                <tr className="">
                                                    <th>Fakülte</th>
                                                    <td> {akademikGorev.fAKULTEBILGISIField}</td>
                                                </tr>
                                                <tr className="">
                                                    <th>Bölüm</th>
                                                    <td>{akademikGorev.bOLUMBILGISIField}</td>
                                                </tr>
                                                <tr>
                                                    <th>Başlangıç - Bitiş Yıl</th>
                                                    <td>{`${akademikGorev.bASTAR1Field} / ${akademikGorev.bITTAR1Field ? akademikGorev.bITTAR1Field : "-"}`}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    })
                    : this.getNotFoundContent();
                break;
            case 4:
                let IdariGorevListesi = JSON.parse(this.state.Data.IdariGorevListesi);

                return IdariGorevListesi && IdariGorevListesi.data ?
                    IdariGorevListesi.data.map((idariGorev) => {
                        return <div className="mt-5">
                            <div className="cardList">
                                <div className="card">
                                    <div className="cardHeading">{idariGorev.gOREV_ADIField}</div>
                                    <div className="card-content">
                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <th className="w-25">Üniversite</th>
                                                    <td> {idariGorev.uNV_BIRIM_ADIField}</td>
                                                </tr>
                                                <tr className="">
                                                    <th>Birim</th>
                                                    <td> {idariGorev.bOLUMField}</td>
                                                </tr>
                                                <tr className="">
                                                    <th>Görev</th>
                                                    <td>{idariGorev.gOREV_ADIField}</td>
                                                </tr>
                                                <tr>
                                                    <th>Başlangıç - Bitiş Yıl</th>
                                                    <td>{`${idariGorev.bAS_TARField} / ${idariGorev.bIT_TARField ? idariGorev.bIT_TARField : "-"}`}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    })
                    : this.getNotFoundContent();
                break;
            case 5:
                let MakaleBilgisi = JSON.parse(this.state.Data.MakaleBilgisi);

                return <div className="mt-5">
                    <div className="detail-list">
                        {MakaleBilgisi && MakaleBilgisi.data ?
                            MakaleBilgisi.data.map((makale, index) => {
                                let makaleDetay = makale.docMakaleListesiDetay && makale.docMakaleListesiDetay.length > 0 ? makale.docMakaleListesiDetay[0] : {};
                                let keywords = makaleDetay.aNAHTAR_KELIMEField ? makaleDetay.aNAHTAR_KELIMEField.split(",") : [];
                                return <div className="item">
                                    <div className="headLine">{makaleDetay.mAKALE_ADIField}
                                    </div>
                                    <div className="content"><strong>Yazar(lar):</strong> {makaleDetay.yAZAR_ADIField}<br />
                                        <strong>Yayın Yeri:</strong> {makaleDetay.dERGI_ADIField}, {makaleDetay.yILField}<br />
                                        <strong>Cilt:</strong> {makaleDetay.cILTField} <strong>Sayı:</strong> {makaleDetay.sAYIField}
                                        <strong> Sayfa:</strong> {makaleDetay.iLK_SAYFAField} - {makaleDetay.sON_SAYFAField}<br />
                                    </div>
                                    <div className="tag-list">
                                        {keywords.map((keyword: string, index) => {
                                            let colors = ["red", "green", "blue", "purple", "orange", "black"];
                                            return <span className={`tag ${colors[index]}`}>{keyword.trim()}</span>
                                        })}
                                    </div>
                                </div>
                            })
                            : this.getNotFoundContent()
                        }
                    </div>
                </div>
                break;
            case 6:
                let KitapBilgisi = JSON.parse(this.state.Data.KitapBilgisi);

                return <div className="mt-5">
                    <div className="detail-list">
                        {KitapBilgisi && KitapBilgisi.data ?
                            KitapBilgisi.data.map((makale, index) => {
                                let makaleDetay = makale.docKitapListesiDetayV1 && makale.docKitapListesiDetayV1.length > 0 ? makale.docKitapListesiDetayV1[0] : {};
                                let keywords = makaleDetay.aNAHTAR_KELIMEField ? makaleDetay.aNAHTAR_KELIMEField.split(",") : [];
                                return <div className="item">
                                    <div className="headLine">{makaleDetay.kITAP_ADIField}
                                    </div>
                                    <div className="content"><strong>Bölüm Adı:</strong> {makaleDetay.bOLUM_ADIField}<br />
                                        <strong>Yazar:</strong> {makaleDetay.yAZAR_ADIField}<br />
                                        <strong>Yayın Yeri:</strong> {makaleDetay.yAYIN_EVIField} <strong>Editör:</strong> {makaleDetay.eDITOR_ADIField}
                                        <strong> Sayfa:</strong> {makaleDetay.sAYFA_SAYISIField}<br />
                                    </div>
                                    <div className="tag-list">
                                        {keywords.map((keyword: string, index) => {
                                            let colors = ["red", "green", "blue", "purple", "orange", "black"];
                                            return <span className={`tag ${colors[index]}`}>{keyword.trim()}</span>
                                        })}
                                    </div>
                                </div>
                            })
                            : this.getNotFoundContent()
                        }
                    </div>
                </div>
                break;
            case 7:
                let BildiriBilgisi = JSON.parse(this.state.Data.BildiriBilgisi);

                return <div className="mt-5">
                    <div className="detail-list">
                        {BildiriBilgisi && BildiriBilgisi.data ?
                            BildiriBilgisi.data.map((makaleDetay, index) => {
                                return <div className="item">
                                    <div className="headLine">{makaleDetay.bildirI_ADI}
                                    </div>
                                    <div className="content"><strong>Yazar(lar):</strong> {makaleDetay.yAZAR_ADIField}<br />
                                        <strong>Etkinlik Adı:</strong> {makaleDetay.etkinliK_ADI}<br />
                                        <strong> Etkinlik Tarihi:</strong> {makaleDetay.etkinliK_BAS_TARIHI} - {makaleDetay.etkinliK_BIT_TARIHI ? makaleDetay.etkinliK_BIT_TARIHI : "-"}<br />
                                    </div>
                                    <div className="tag-list">
                                        {makaleDetay.kapsaM_AD && <span className={`tag red`}>{makaleDetay.kapsaM_AD}</span>}
                                        {makaleDetay.basiM_TURU_AD && <span className={`tag green`}>{makaleDetay.basiM_TURU_AD}</span>}
                                        {makaleDetay.yayiN_DURUMU_AD && <span className={`tag blue`}>{makaleDetay.yayiN_DURUMU_AD}</span>}
                                    </div>
                                </div>
                            })
                            : this.getNotFoundContent()
                        }
                    </div>
                </div>
                break;
            case 8:
                let ProjeListesi = JSON.parse(this.state.Data.ProjeListesi);

                return <div className="mt-5">
                    <div className="detail-list">
                        {ProjeListesi && ProjeListesi.data ?
                            ProjeListesi.data.map((makale, index) => {
                                let makaleDetay = makale.doc_projeListesiDetay && makale.doc_projeListesiDetay.length > 0 ? makale.doc_projeListesiDetay[0] : {};
                                let keywords = makaleDetay.aNAHTAR_KELIMEField ? makaleDetay.aNAHTAR_KELIMEField.split(",") : [];
                                return <div className="item">
                                    <div className="headLine">{makaleDetay.pROJE_ADField}
                                    </div>
                                    <div className="content"><strong>Proje Türü:</strong> {makaleDetay.pROJE_TURU_ADField}<br />
                                        <strong>Proje Konusu:</strong> {makaleDetay.pROJE_KONUSUField}<br />
                                    </div>
                                    <div className="tag-list">
                                        {makaleDetay.kAPSAM_ADField && <span className={`tag red`}>{makaleDetay.kAPSAM_ADField}</span>}
                                        {makaleDetay.pROJE_KONUMU_ADField && <span className={`tag green`}>{makaleDetay.pROJE_KONUMU_ADField}</span>}
                                        {makaleDetay.pROJE_DURUMU_ADField && <span className={`tag blue`}>{makaleDetay.pROJE_DURUMU_ADField}</span>}
                                    </div>
                                </div>
                            })
                            : this.getNotFoundContent()
                        }
                    </div>
                </div>
                break;
            case 9:
                let SanatsalFaal = JSON.parse(this.state.Data.SanatsalFaal);

                return <div className="mt-5">
                    <div className="detail-list">
                        {SanatsalFaal && SanatsalFaal.data ?
                            SanatsalFaal.data.map((makaleDetay, index) => {
                                let keywords = makaleDetay.aNAHTAR_KELIMEField ? makaleDetay.aNAHTAR_KELIMEField.split(",") : [];
                                return <div className="item">
                                    <div className="headLine">{makaleDetay.eTKINLIK_ADIField}
                                    </div>
                                    <div className="content"><strong>Yer:</strong> {makaleDetay.eTKINLIK_YERIField}<br />
                                        <strong>Düzenleyen(ler):</strong> {makaleDetay.dUZENLEYENLERField}<br />
                                        <strong>Başlangıç - Bitiş Tarihi:</strong> {makaleDetay.bAS_TARIHField} -  {makaleDetay.bIT_TARIHField}<br />
                                    </div>
                                    <div className="tag-list">
                                        {makaleDetay.kAPSAM_ADField && <span className={`tag red`}>{makaleDetay.kAPSAM_ADField}</span>}
                                        {makaleDetay.eTKINLIK_ADIField && <span className={`tag green`}>{makaleDetay.eTKINLIK_ADIField}</span>}
                                        {makaleDetay.dIL_ADIField && <span className={`tag blue`}>{makaleDetay.dIL_ADIField}</span>}
                                    </div>
                                </div>
                            })
                            : this.getNotFoundContent()
                        }
                    </div>
                </div>
                break;
            case 10:
                let TezDanismanListesi = JSON.parse(this.state.Data.TezDanismanListesi);

                return <div className="mt-5">
                    <div className="detail-list">
                        {TezDanismanListesi && TezDanismanListesi.data ?
                            TezDanismanListesi.data.map((makaleDetay, index) => {
                                let keywords = makaleDetay.aNAHTAR_KELIMEField ? makaleDetay.aNAHTAR_KELIMEField.split(",") : [];
                                return <div className="item">
                                    <div className="headLine">{makaleDetay.tEZ_ADIField}
                                    </div>
                                    <div className="content"><strong>Hazırlayan Adı Soyad:</strong> {makaleDetay.yAZAR_ADIField} {makaleDetay.yAZAR_SOYADIField}<br />
                                        <strong>Üniversite:</strong> {makaleDetay.uNIVERSITE_ADField}<br />
                                    </div>
                                    <div className="tag-list">
                                        {makaleDetay.tUR_ADIField && <span className={`tag red`}>{makaleDetay.tUR_ADIField}</span>}
                                        {makaleDetay.yILField && <span className={`tag green`}>{makaleDetay.yILField}</span>}
                                        {makaleDetay.dURUM_ADIField && <span className={`tag blue`}>{makaleDetay.dURUM_ADIField}</span>}
                                    </div>
                                </div>
                            })
                            : this.getNotFoundContent()
                        }
                    </div>
                </div>
                break;
            case 11:
                let DersListesi = JSON.parse(this.state.Data.DersListesi);

                return <div className="mt-5">
                    <div>
                        {DersListesi && DersListesi.data ?
                            <div>
                                <ul role="tablist" className="nav nav-tabs">
                                    {
                                        this.groupBy(DersListesi.data, "aKADEMIK_YILField").map((dersListesi, index) => {
                                            let value = dersListesi[0];
                                            return <li className="nav-item"><a data-bs-toggle="tab" href="javascript:void(0)" role="tab"
                                                aria-controls={`lesson${this.slugify(value.dERS_IDField)}`} aria-selected={index === 0 ? "true" : "false"}
                                                id={`lessonTab${this.slugify(value.dERS_IDField)}`} data-bs-target={`#lesson${this.slugify(value.dERS_IDField)}`} className={`nav-link ${index === 0 ? "active" : ""}`} >{value.aKADEMIK_YILField}</a></li>
                                        })
                                    }
                                </ul>
                                <div className="tab-content" id="timelineTabContent">

                                    {
                                        this.groupBy(DersListesi.data, "aKADEMIK_YILField").map((dersListesi, index) => {
                                            let value = dersListesi[0];
                                            return <div className={`tab-pane fade${index === 0 ? "show active" : ""}`} id={`lesson${this.slugify(value.dERS_IDField)}`} role="tabpanel" aria-labelledby={`lessonTab${this.slugify(value.dERS_IDField)}`}>
                                                <table className="table table-striped responsive">
                                                    <thead>
                                                        <tr>
                                                            <th> Ders Adı
                                                            </th>
                                                            <th> Öğrenim
                                                                Derecesi </th>
                                                            <th> Öğrenim
                                                                Dili </th>
                                                            <th> Ders
                                                                Saati </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {dersListesi.map((ders, dersIndex) => {
                                                            return <tr>
                                                                <td data-thead="Ders Adı">{ders.dERS_ADIField}</td>
                                                                <td data-thead="Öğrenim Derecesi">{ders.oGRENIM_ADIField}</td>
                                                                <td data-thead="Öğrenim Dili">{ders.dIL_ADIField}</td>
                                                                <td data-thead="Ders Saati">{ders.dERS_SAATIField}</td>
                                                            </tr>

                                                        }
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                        }
                                        )}

                                </div>
                            </div>
                            : this.getNotFoundContent()
                        }
                    </div>
                </div>
                break;
            case 12:
                let ArastirmaSertifkaBilgisi = JSON.parse(this.state.Data.ArastirmaSertifkaBilgisi);

                return ArastirmaSertifkaBilgisi && ArastirmaSertifkaBilgisi.data ?
                    ArastirmaSertifkaBilgisi.data.map((ogrenimBilgisi) => {
                        return <div className="mt-5">
                            <div className="cardList">
                                <div className="card">
                                    <div className="cardHeading">{this.clearText(ogrenimBilgisi.aDIField)}</div>
                                    <div className="card-content">
                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <th className="w-25">İçerik</th>
                                                    <td> {ogrenimBilgisi.uNV_BIRIM_ADIField}</td>
                                                </tr>
                                                <tr>
                                                    <th className="">Tür</th>
                                                    <td> {ogrenimBilgisi.tUR_ADIField}</td>
                                                </tr>
                                                <tr className="">
                                                    <th>Kurum / Unvan</th>
                                                    <td> {ogrenimBilgisi.uNVAN_ADField}</td>
                                                </tr>
                                                <tr className="">
                                                    <th>Kapsam</th>
                                                    <td>{ogrenimBilgisi.kAPSAM_ADField}</td>
                                                </tr>
                                                <tr>
                                                    <th>Yer</th>
                                                    <td>{`${ogrenimBilgisi.yERField}`}</td>
                                                </tr>
                                                <tr>
                                                    <th>Başlangıç - Bitiş Tarihi</th>
                                                    <td>{`${ogrenimBilgisi.bASTARField} / ${ogrenimBilgisi.bITTARField}`}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    })
                    : this.getNotFoundContent();
                break;
            case 13:
                let TasarimBilgisi = this.state.Data.TasarimBilgisi ? JSON.parse(this.state.Data.TasarimBilgisi) : null;
                let OdulListesi = this.state.Data.OdulListesi ? JSON.parse(this.state.Data.OdulListesi) : null;
                let PatentBilgisi = this.state.Data.PatentBilgisi ? JSON.parse(this.state.Data.PatentBilgisi) : null;

                return <div className="mt-5">
                    <div>
                        <ul role="tablist" className="nav nav-tabs">
                            <li className="nav-item"><a data-bs-toggle="tab" href="javascript:void(0)" role="tab"
                                aria-controls={`awards${this.slugify("Tasarımlar")}`} aria-selected={"true"}
                                id={`awardsTab${this.slugify("Tasarımlar")}`} data-bs-target={`#awards${this.slugify("Tasarımlar")}`} className={`nav-link ${"active"}`} >{"Tasarımlar"}</a></li>
                            <li className="nav-item"><a data-bs-toggle="tab" href="javascript:void(0)" role="tab"
                                aria-controls={`awards${this.slugify("Ödüller")}`} aria-selected={"false"}
                                id={`awardsTab${this.slugify("Ödüller")}`} data-bs-target={`#awards${this.slugify("Ödüller")}`} className={`nav-link ${""}`} >{"Ödüller"}</a></li>
                            <li className="nav-item"><a data-bs-toggle="tab" href="javascript:void(0)" role="tab"
                                aria-controls={`awards${this.slugify("Patentler")}`} aria-selected={"false"}
                                id={`awardsTab${this.slugify("Patentler")}`} data-bs-target={`#awards${this.slugify("Patentler")}`} className={`nav-link ${""}`} >{"Patentler"}</a></li>
                        </ul>

                        <div className="tab-content" id="awardsTimelineTabContent">
                            <div className={`tab-pane fade show active`} id={`awards${this.slugify("Tasarımlar")}`} role="tabpanel" aria-labelledby={`awardsTab${this.slugify("Tasarımlar")}`}>
                                {TasarimBilgisi && TasarimBilgisi.data ?
                                    TasarimBilgisi.data.map((ogrenimBilgisi) => {
                                        return <div className="mt-5">
                                            <div className="cardList">
                                                <div className="card">
                                                    <div className="cardHeading">{ogrenimBilgisi.tASARIM_ADIField}</div>
                                                    <div className="card-content">
                                                        <table className="table">
                                                            <tbody>
                                                                <tr>
                                                                    <th className="w-25">Tasarım Türü</th>
                                                                    <td> {ogrenimBilgisi.tASARIM_TURU_ADIField}</td>
                                                                </tr>
                                                                <tr className="">
                                                                    <th>Tasarım Sahipleri</th>
                                                                    <td> {ogrenimBilgisi.tASARIM_SAHIPLERIField}</td>
                                                                </tr>
                                                                <tr className="">
                                                                    <th>Tasarım Özeti</th>
                                                                    <td>{ogrenimBilgisi.tASARIM_OZETIField}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Başlangıç - Bitiş Tarihi</th>
                                                                    <td>{`${ogrenimBilgisi.bAS_TARIHIField} / ${ogrenimBilgisi.bITIS_TARIHIField}`}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                    : this.getNotFoundContent()}
                            </div>
                            <div className={`tab-pane fade`} id={`awards${this.slugify("Ödüller")}`} role="tabpanel" aria-labelledby={`awardsTab${this.slugify("Ödüller")}`}>
                                {OdulListesi && OdulListesi.data ?
                                    OdulListesi.data.map((ogrenimBilgisi) => {
                                        return <div className="mt-5">
                                            <div className="cardList">
                                                <div className="card">
                                                    <div className="cardHeading">{ogrenimBilgisi.oDUL_ADIField}</div>
                                                    <div className="card-content">
                                                        <table className="table">
                                                            <tbody>
                                                                <tr>
                                                                    <th className="w-25">Kurum Türü</th>
                                                                    <td> {ogrenimBilgisi.tASARIM_TURU_ADIField} {ogrenimBilgisi.iSYERI_TURU_ADIField}</td>
                                                                </tr>
                                                                <tr className="">
                                                                    <th>Kurum</th>
                                                                    <td> {ogrenimBilgisi.kURULUS_ADIField}</td>
                                                                </tr>
                                                                <tr className="">
                                                                    <th>Yıl</th>
                                                                    <td>{ogrenimBilgisi.oDUL_TARIHField}</td>
                                                                </tr>
                                                                <tr className="">
                                                                    <th>Ülke</th>
                                                                    <td>{ogrenimBilgisi.uLKE_ADField}</td>
                                                                </tr>
                                                                <tr className="">
                                                                    <th>Tanım</th>
                                                                    <td>{ogrenimBilgisi.oDUL_ACIKLAMAField}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                    : this.getNotFoundContent()}
                            </div>
                            <div className={`tab-pane fade`} id={`awards${this.slugify("Patentler")}`} role="tabpanel" aria-labelledby={`awardsTab${this.slugify("Patentler")}`}>
                                {PatentBilgisi && PatentBilgisi.data ?
                                    PatentBilgisi.data.map((ogrenimBilgisi) => {
                                        return <div className="mt-5">
                                            <div className="cardList">
                                                <div className="card">
                                                    <div className="cardHeading">{ogrenimBilgisi.oDUL_ADIField}</div>
                                                    <div className="card-content">
                                                        <table className="table">
                                                            <tbody>
                                                                <tr>
                                                                    <th className="w-25">Kurum Türü</th>
                                                                    <td> {ogrenimBilgisi.tASARIM_TURU_ADIField} {ogrenimBilgisi.iSYERI_TURU_ADIField}</td>
                                                                </tr>
                                                                <tr className="">
                                                                    <th>Kurum</th>
                                                                    <td> {ogrenimBilgisi.kURULUS_ADIField}</td>
                                                                </tr>
                                                                <tr className="">
                                                                    <th>Yıl</th>
                                                                    <td>{ogrenimBilgisi.oDUL_TARIHField}</td>
                                                                </tr>
                                                                <tr className="">
                                                                    <th>Ülke</th>
                                                                    <td>{ogrenimBilgisi.uLKE_ADField}</td>
                                                                </tr>
                                                                <tr className="">
                                                                    <th>Tanım</th>
                                                                    <td>{ogrenimBilgisi.oDUL_ACIKLAMAField}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                    : this.getNotFoundContent()}
                            </div>

                        </div>

                    </div>
                </div>
                break;
            case 14:
                let UnvDisiDeneyimListesi = JSON.parse(this.state.Data.UnvDisiDeneyimListesi);

                return UnvDisiDeneyimListesi && UnvDisiDeneyimListesi.data ?
                    UnvDisiDeneyimListesi.data.map((akademikGorev) => {
                        return <div className="mt-5">
                            <div className="cardList">
                                <div className="card">
                                    <div className="cardHeading">{akademikGorev.gOREV_ADIField}</div>
                                    <div className="card-content">
                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <th className="w-25">İş Yeri Türü</th>
                                                    <td> {akademikGorev.iSYERI_TUR_ADField}</td>
                                                </tr>
                                                <tr className="">
                                                    <th>Çalıştığı Kurum/Kuruluş Adı</th>
                                                    <td> {akademikGorev.kURULUS_ADIField}</td>
                                                </tr>
                                                <tr className="">
                                                    <th>İş Tanımı</th>
                                                    <td>{akademikGorev.iS_TANIMIField}</td>
                                                </tr>
                                                <tr>
                                                    <th>Başlangıç - Bitiş Yıl</th>
                                                    <td>{`${akademikGorev.bAS_TARField} / ${akademikGorev.bIT_TARField ? akademikGorev.bIT_TARField : "-"}`}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    })
                    : this.getNotFoundContent();
                break;
            case 15:
                let EditorlukBilgisi = JSON.parse(this.state.Data.EditorlukBilgisi);

                return EditorlukBilgisi && EditorlukBilgisi.data ?
                    EditorlukBilgisi.data.map((akademikGorev) => {
                        return <div className="mt-5">
                            <div className="cardList">
                                <div className="card">
                                    <div className="cardHeading">{akademikGorev.yAYIN_ADIField}</div>
                                    <div className="card-content">
                                        <table className="table table-striped">
                                            <tbody>
                                                <tr>
                                                    <th scope="row">Yazar(lar)</th>
                                                    <td colSpan={3}>{akademikGorev.yAZAR_ADIField}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Yayın Türü</th>
                                                    <td>{akademikGorev.eDITORLUK_TUR_ADField}</td>
                                                    <th scope="row">Editörlük Görevi</th>
                                                    <td>{akademikGorev.eDITOR_GOREV_ADField}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Yayınevi</th>
                                                    <td>{akademikGorev.yAYIN_EVIField}</td>
                                                    <th scope="row">Endeks</th>
                                                    <td>{akademikGorev.eNDEKSField}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Kapsam</th>
                                                    <td>{akademikGorev.kAPSAM_ADField}</td>
                                                    <th scope="row">Yayın Dili</th>
                                                    <td>{akademikGorev.yAYIN_DILI_ADIField}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Yıl</th>
                                                    <td>{akademikGorev.yILField}</td>
                                                    <th scope="row">İsbn</th>
                                                    <td>{akademikGorev.iSSNField}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Ülke</th>
                                                    <td>{akademikGorev.uLKE_ADIField}</td>
                                                    <th scope="row">Şehir</th>
                                                    <td>{akademikGorev.sEHIRField}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Başlangıç Tarihi</th>
                                                    <td>{akademikGorev.bAS_TARIHField}</td>
                                                    <th scope="row">Bitiş Tarihi</th>
                                                    <td>{akademikGorev.bIT_TARIHField ? akademikGorev.bIT_TARIHField : "-"}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Alan Bilgisi</th>
                                                    <td colSpan={3}>{akademikGorev.aLAN_BILGISIField ? akademikGorev.aLAN_BILGISIField.replace(/&lt;/g, ' < ').replace(/&gt;/g, ' > ').replace(/&amp;/g, ' & ') : ""}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    })
                    : this.getNotFoundContent();
                break;
            case 16:
                let HakemlikBilgisi = JSON.parse(this.state.Data.HakemlikBilgisi);

                return HakemlikBilgisi && HakemlikBilgisi.data ?
                    HakemlikBilgisi.data.map((akademikGorev) => {
                        return <div className="mt-5">
                            <div className="cardList">
                                <div className="card">
                                    <div className="cardHeading">{akademikGorev.hAKEMLIK_TURU_ADField}</div>
                                    <div className="card-content">
                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <th className="w-25">Alan Bilgisi</th>
                                                    <td> {akademikGorev.aLAN_BILGISIField}</td>
                                                </tr>
                                                <tr className="">
                                                    <th>Kapsam</th>
                                                    <td> {akademikGorev.kAPSAM_ADField}</td>
                                                </tr>
                                                <tr className="">
                                                    <th>Yayın Yeri</th>
                                                    <td>{akademikGorev.yAYIN_YERIField}</td>
                                                </tr>
                                                <tr className="">
                                                    <th>Yayın Dili</th>
                                                    <td>{akademikGorev.yAYIN_DILI_ADIField}</td>
                                                </tr>
                                                <tr className="">
                                                    <th>Ülke</th>
                                                    <td>{akademikGorev.uLKE_ADIField}</td>
                                                </tr>
                                                <tr>
                                                    <th>Yıl</th>
                                                    <td>{`${akademikGorev.yILField}`}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    })
                    : this.getNotFoundContent();
                break;
            default:
                return <div></div>;
        }
    }

    private clearText = (text)=>{
        return text.replace(/&lt;/g, ' < ').replace(/&gt;/g, ' > ').replace(/&amp;/g, ' & ');
    }

    private slugify = (text) => {
        return text
            .toString()
            .normalize('NFD')                   // split an accented letter in the base letter and the acent
            .replace(/[\u0300-\u036f]/g, '')   // remove all previously split accents
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '')
            .replace(/[^\w\-]+/g, '')
            .replace(/\-\-+/g, '');
    };

    private groupBy(collection, property) {
        var i = 0, val, index,
            values = [], result = [];
        for (; i < collection.length; i++) {
            val = collection[i][property];
            index = values.indexOf(val);
            if (index > -1)
                result[index].push(collection[i]);
            else {
                values.push(val);
                result.push([collection[i]]);
            }
        }
        return result;
    }

    private getRightSide = () => {
        return <div className="rightSidebar">
            <div className="pageTitle">
                <h1>{this.leftMenuOptions[this.state.SelectedMenuIndex]}</h1>
            </div>
            {this.getDetailComponent()}
        </div>
    }

    private onSelectMenu = (menuIndex) => {
        this.setState({ SelectedMenuIndex: menuIndex });
        $(".navBar .hamburger").click();
    }

    private getRender = () => {
        switch (this.state.FormState) {
            case FormState.Loading:
                return <div className="loading-container">
                    <div className="lds-ripple"><div></div><div></div></div>
                </div>
            default:
                return <div className="container mt-5">
                    {this.getLeftMenu()}
                    {this.getRightSide()}
                </div>
        }
    }

    render() {
        return <div className="main mt-5">
            {this.getRender()}
        </div>
    }
}



// WEBPACK FOOTER //
// ./Views/src/Academician/ah-academician-detail-view.tsx